import React from "react";
import { useState, Dispatch} from "react";
import { Container, Row, Col } from "react-bootstrap";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import contactImg from '../assets/img/contact-img.svg';


interface IContactProp {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string;
}

interface Props  {
  category: string,
  value: string
}

interface IStatus  {
  success: boolean,
  message: string
}

export const Contact = () => {

  
  const [formDetails, setFormDetails] = useState<IContactProp>({
    firstName: "", 
    lastName: "", 
    email: "",
    phone: "",
    message: ""
  });

  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState<IStatus>({success: false, message: ""});

  const onFormUpdate = (category: string, value: string) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }

  const handleSubmit = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    setButtonText("Sending...");
    let response = await fetch("http://localhost:5000/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(formDetails),
    });
    setButtonText("Send");
    let result = await response.json();
    setFormDetails(formDetails);
    if (result.code == 200) {
      setStatus({ success: true, message: 'Message sent successfully'});
    } else {
      setStatus({ success: false, message: 'Something went wrong, please try again later.'});
    }
  };

  
  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h4>Get In Touch</h4>
                < br />
                <h3>MAG INSTITUTE OF MARITIME ACADEMY</h3>
                Office No: 307, Kukreja Center, Plot No.13, Sector-11 <br />
                CBD Belapur, Navi Mumbai - 400 614, Maharashtra <br /> <br />
                Tel: 022 497655550, Email: admin@maginstitute.com
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
